module.exports = __webpack_public_path__ + "img/blimpy3.a0439899.jpg";